exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-radio .v-input--selection-controls__ripple{width:24px;height:24px;top:-7px!important;left:-7px!important}", ""]);

// exports
